import angular from 'angular';

module.exports = angular.module('market.models.listing-geo-json', [])
.factory('ListingGeoJson', function($resource) {
  return $resource('/api/v1/listings/geo', {}, {
    query: {
      isArray: false
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/listing-geo-json.js
 **/